import { fork, put, select, takeEvery } from 'redux-saga/effects'

import { ActionType, IGetProduct, IPostConnectProduct, PAGE_SIZE_PRODUCT_LIST } from './model'
import { Action, ActionCallback, DEFAULT_ITEM_LIST, IAxiosResponse } from '../model'
import { createApiCall } from 'services/api'
import { history } from '../configureStore'
import { entityApiCall } from 'services'
import { getStorageUrl } from '../../utils'

function buildProductLogoThumb(entry: any) {
  return entry.newLogo ? entry.newLogo.imageSizeUrls.main : getStorageUrl('product-logo', entry.logo, true)
}

export function* getProductListSaga(): Generator {
  yield takeEvery(ActionType.GET_PRODUCT_LIST, function* (action: Action<{ page: number }>) {
    try {
      const { payload } = action
      const {
        store: { productList },
      } = yield select()
      const { data, status }: IAxiosResponse = yield createApiCall({
        apiType: 'product',
        url: '/product',
        params: {
          limit: PAGE_SIZE_PRODUCT_LIST,
          offset: payload.page * PAGE_SIZE_PRODUCT_LIST,
        },
      })
      yield put({
        type: ActionType.SET_PRODUCT_LIST,
        payload:
          status === 200
            ? {
                items: payload.page ? [...productList.items, ...data.items] : data.items,
                totalCount: data.totalCount,
                loading: false,
              }
            : DEFAULT_ITEM_LIST,
      })
    } catch (error) {
      console.error(error)
    }
  })
}

export function* getProductSaga(): Generator {
  yield takeEvery(ActionType.GET_PRODUCT, function* (action: Action<IGetProduct>) {
    try {
      const { payload } = action
      const { data, status }: IAxiosResponse = yield createApiCall({
        apiType: 'product',
        url: `/product/${payload.id}`,
        params: {
          type: payload.type,
        },
      })
      if (status === 200) {
        yield put({
          type: ActionType.SET_PRODUCT,
          payload: data,
        })
      } else {
        history.push('/404')
      }
    } catch (error) {
      // error
    }
  })
}

export function* getProductNewSaga(): Generator {
  yield takeEvery(ActionType.GET_PRODUCT_NEW, function* (action: Action<IGetProduct>) {
    try {
      const { payload } = action
      const predicates: any = [{ field: 'id', operator: 'EQUALS', values: [payload.id] }]
      const { data, status }: IAxiosResponse = yield entityApiCall({
        method: 'POST',
        url: '/ng/v1/product/get',
        data: {
          selector: {
            fields: [
              'id',
              'name',
              'logo',
              'newLogo',
              'media',
              'newMedia',
              'vendor',
              'link',
              'status',
              'shortDescription',
              'description',
              'functions',
              'createdAt',
              'isMadeInRus',
              'order',
              'typeId',
              'typeName',
              'isConnected',
              'isNew',
            ],
            predicates: predicates,
          },
        },
      })

      if (status === 200) {
        const entry = data.page.entries[0]
        const product = {
          ...entry,
          logo: buildProductLogoThumb(entry),
          version: 1,
        }
        yield put({
          type: ActionType.SET_PRODUCT_NEW,
          payload: product,
        })
      } else {
        history.push('/404')
      }
    } catch (error) {
      // error
    }
  })
}

export function* postConnectProductSaga(): Generator {
  yield takeEvery(ActionType.POST_CONNECT_PRODUCT, function* (action: ActionCallback<IPostConnectProduct>) {
    try {
      const {
        auth: { clientCompany },
      } = yield select()
      const {
        payload: { clientId, productId },
        callback,
      } = action
      const { status, data }: IAxiosResponse = yield createApiCall({
        apiType: 'task',
        method: 'POST',
        url: `/task/product`,
        data: {
          productId,
          clientId: clientId || clientCompany.id,
        },
      })
      if (status === 200) {
        yield history.push(`/task/${data.id}`)
        callback({ success: true })
      } else {
        callback({ success: false })
      }
    } catch (error) {
      // error
    }
  })
}

export default [fork(getProductSaga), fork(getProductNewSaga), fork(getProductListSaga), fork(postConnectProductSaga)]
